{
  "#SSO": {
    "PAGES": {
      "PLEASE_WAIT": "Please wait...",
      "PROGRESS": "You will be logged in automatically"
    },
    "MESSAGES": {
      "ERROR": {
        "UNAUTHORIZED": "The login key is not valid",
        "NO_CONNECTION": "Could not connect to the server. Please check your internet connection or try again later."
      }
    }
  }
}
